// extracted by mini-css-extract-plugin
export default {"sponsor":"PickSponsorModal-module-a8f877b5d8f46bcd9f38"};